import '@/plugin';
import '@/styles/index.scss';

import liff from '@line/liff';

import { campaign } from '@/json/json_loader';
import {
  Campaign,
  LiffBrowserOnlyKbnConst,
  LiffOnlyKbnConst,
  MobileOnlyKbnConst,
} from '@/models/campaign';
import { LandingPage } from '@/models/landing_page';
import { isMobile } from '@/utils/is_mobile';
import { liffInit } from '@/utils/liff_init';
import { redirectToLine } from '@/utils/redirect_to_line';

type IsFailed = boolean;
const FAILED: IsFailed = true;
const SUCCESS: IsFailed = false;

export const isTargetMobile = (campaign: Campaign, landingPage: LandingPage) =>
  campaign.mobileOnlyKbn === MobileOnlyKbnConst.FollowCms
    ? landingPage.isTargetMobile()
    : campaign.mobileOnlyKbn === MobileOnlyKbnConst.Yes;

export const isTargetLiff = (campaign: Campaign, landingPage: LandingPage) =>
  campaign.liffOnlyKbn === LiffOnlyKbnConst.FollowCms
    ? landingPage.isTargetLiff()
    : campaign.liffOnlyKbn === LiffOnlyKbnConst.Yes;

export const isTargetLiffBrowser = (campaign: Campaign, landingPage: LandingPage) =>
  campaign.liffBrowserOnlyKbn === LiffBrowserOnlyKbnConst.FollowCms
    ? landingPage.isTargetLiffBrowser()
    : campaign.liffBrowserOnlyKbn === LiffBrowserOnlyKbnConst.Yes;

export async function handleLpTarget(
  landingPage: LandingPage,
): Promise<IsFailed> {
  if (
    (isTargetMobile(campaign, landingPage) && !isMobile()) ||
    (isTargetLiffBrowser(campaign, landingPage) && !liff.isInClient())
  ) {
    await redirectToLine(campaign.clientBasicId, campaign.escapeUrl);
    return FAILED;
  }
  if (isTargetLiff(campaign, landingPage) && await liffInit()) {
    return FAILED;
  }
  return SUCCESS;
}
